import { render, staticRenderFns } from "./OrderTransactions.vue?vue&type=template&id=51347a60"
import script from "./OrderTransactions.vue?vue&type=script&lang=js"
export * from "./OrderTransactions.vue?vue&type=script&lang=js"
import style0 from "./OrderTransactions.vue?vue&type=style&index=0&id=51347a60&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports